
export const PROOFSPACE_STRATEGY = 'proofspace'
